import styled from 'styled-components'

export const InputRangeScaleInner = styled.div`
  position: relative;
  margin: 0 30px;
`

InputRangeScaleInner.displayName = 'InputRangeScaleInner'
